/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Verifiedowner2Inputs */

const id_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemilik Terverifikasi`)
};

const ms_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemilik Disahkan`)
};

const da_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekræftet Ejer`)
};

const de_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifizierter Besitzer`)
};

const en_us2_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified Owner`)
};

const es_es2_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propietario verificado`)
};

const es_mx2_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dueño verificado`)
};

const fil_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na-verify na May-ari`)
};

const fr_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propriétaire vérifié`)
};

const it_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietario verificato`)
};

const hu_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hitelesített tulajdonos`)
};

const nl_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geverifieerde eigenaar`)
};

const no_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekreftet eier`)
};

const pl_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweryfikowany właściciel`)
};

const pt_br2_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietário verificado`)
};

const pt_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietário verificado`)
};

const ro_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietar verificat`)
};

const fi_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vahvistettu omistaja`)
};

const sv_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifierad ägare`)
};

const vi_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chủ sở hữu đã xác minh`)
};

const tr_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doğrulanmış Sahip`)
};

const cs_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ověřený vlastník`)
};

const bg_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверен собственик`)
};

const ru_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтверждённый владелец`)
};

const uk_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підтверджений власник`)
};

const ar_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مالك موثق`)
};

const hi_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सत्यापित स्वामी`)
};

const th_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เจ้าของที่ได้รับการยืนยัน`)
};

const ja_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認済み所有者`)
};

const zh_cn2_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已验证拥有者`)
};

const zh_hant1_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已驗證擁有者`)
};

const ko_offerdetail_reviews_verifiedowner2 = /** @type {(inputs: Offerdetail_Reviews_Verifiedowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인증된 소유자`)
};

/**
* | output |
* | --- |
* | "Verified Owner" |
*
* @param {Offerdetail_Reviews_Verifiedowner2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_verifiedowner2 = /** @type {((inputs?: Offerdetail_Reviews_Verifiedowner2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Verifiedowner2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "da") return da_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "de") return de_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "it") return it_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "no") return no_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "th") return th_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_verifiedowner2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_verifiedowner2(inputs)
	return ko_offerdetail_reviews_verifiedowner2(inputs)
});
export { offerdetail_reviews_verifiedowner2 as "offerDetail.reviews.verifiedOwner" }